var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-list',{staticClass:"list"},_vm._l((_vm.list),function(item,index){return _c('van-cell',{key:index},[_c('div',{staticClass:"card",on:{"click":function($event){return _vm.onClick(item)}}},[_c('img',{attrs:{"src":item.image}}),_c('span',[_vm._v(_vm._s(item.title))])])])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }